// src/firebase.js — FIXED PRODUCTION VERSION WITH DEBUG TOKEN
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, getToken } from "firebase/app-check";

const firebaseConfig = {
  apiKey: "AIzaSyDzT-ya9neg3evV22HvP5EoSBXI36OqtN0",
  authDomain: "esdras-app.firebaseapp.com",
  projectId: "esdras-app",
  storageBucket: "esdras-app.firebasestorage.app",
  messagingSenderId: "485441053128",
  appId: "1:485441053128:web:e699350dcd2da71d2be0fd",
  measurementId: "G-9YQ45H9RXG"
};

const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app, "us-central1");
export const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');

export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;

// ==================== APP CHECK (Fixed with your debug token) ====================
let appCheckInstance;

if (typeof window !== "undefined") {
  const isDevelopment = 
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1" ||
    window.location.hostname.includes("vercel.app");

  // Your new debug token
  if (isDevelopment) {
    self.FIREBASE_APPCHECK_DEBUG_TOKEN = "DEC89483-871A-4F39-9E11-7912FBBA8C56";
    console.log("🛠️ App Check: Debug Mode Active (Vercel + Local)");
  }

  try {
    appCheckInstance = initializeAppCheck(app, {
      provider: new ReCaptchaEnterpriseProvider('6LdHd1AsAAAAAFki7vT0x5aqOyTCo-IazUQ44mhY'),
      isTokenAutoRefreshEnabled: true
    });
  } catch (err) {
    console.warn("App Check initialization warning:", err);
  }
}

export const getAppCheckToken = async () => {
  if (!appCheckInstance) return null;
  try {
    const result = await getToken(appCheckInstance, false);  // Note: getToken needs to be imported
    return result.token;
  } catch (err) {
    console.error("App Check token error:", err);
    return null;
  }
};

export { app };
export default app;
